import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { postajob , getProfileDetail, getExperiences, getEducations, generatePdfHtml } from './../../../API/FetchCall';

//import Html2Pdf from 'js-html2pdf';

//import {useReactToPrint} from 'react-to-print';

const IMG_URL = "http://localhost:5005/"; //"https://api.bewise.in/";

class DownloadProfile extends Component {

  constructor(props) {
    super(props);
    this.state = {
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data")),

    }

    this.teacher_id = this.props.match.params.id;
  
     /*
    var element = document.getElementById('element-to-print');
    var opt = {
      margin:       1,
      filename:     'myfile.pdf',
      image:        { type: 'jpeg', quality: 0.98 },
      html2canvas:  { scale: 2 },
      jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
    };
     
    // New Promise-based usage:
    Html2Pdf().from(element).set(opt).save();
    */
   
  }
  
 

 

  componentDidMount() {

          this.generatePdfHtml();

  }

  generatePdfHtml(){

      let req = JSON.stringify({
        teacher_id:this.teacher_id
      })
      
      generatePdfHtml(req).then((response) => {
        
            if(response.status==1){

               /*

                var html = response.html;
                var options = { filename: 'my-file.pdf', jsPDF: {unit: 'mm', format: 'a4', orientation: 'p'}};
                const exporter = new Html2Pdf(html, options);
                exporter.getPdf(true);
                */
            }

     })


  } 
 
 
  render() {
    
    const { userinfo, experiences, educations } = this.state;

        return (
            <React.Fragment>
                
              
            </React.Fragment>
        )
    }

}

export default DownloadProfile;


// WEBPACK FOOTER //
// ./src/components/bewise/wiseconnect/downloadprofile.jsx